import script from "./StepUploadID.vue?vue&type=script&setup=true&lang=js"
export * from "./StepUploadID.vue?vue&type=script&setup=true&lang=js"

import "./StepUploadID.vue?vue&type=style&index=0&id=ee78d0f0&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee78d0f0"]])

export default __exports__